import React, { EventHandler } from 'react';
import { TestResultSvbPvb } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { Input } from '../../../Form';
import ButtonToggle from '../../../Button/ButtonToggle';
import { yesNoOptions } from '../../options';

type SvbPvbTestResultEditProps = {
  test: TestResultSvbPvb;
  onFormInputChange: EventHandler<any>;
};

const didNotOpenOptions = yesNoOptions;

const SvbPvbTestResultEdit: React.FC<SvbPvbTestResultEditProps> = ({
  test,
  onFormInputChange,
}) => {
  return (
    <>
      <AccordionItem
        label="Did Not Fully Open"
        alignItems="center"
        value={
          <ButtonToggle
            name="didNotOpen"
            onClick={onFormInputChange}
            buttonOptions={didNotOpenOptions}
            my={-1}
            value={typeof test.didNotOpen !== 'number' ? 0 : test.didNotOpen}
          />
        }
      />
      <AccordionItem
        label="Air Inlet Opened At"
        alignItems="center"
        as="label"
        value={
          <Input
            required={
              typeof test.didNotOpen !== 'number' || test.didNotOpen === 0
            }
            onChange={onFormInputChange}
            variant="accordion"
            type="number"
            name="openedAt"
            value={test.openedAt}
            step="0.1"
            min="0"
            max="200"
            autoComplete="off"
          />
        }
      />
      <AccordionItem
        label="Check Valve"
        alignItems="center"
        as="label"
        value={
          <Input
            required
            onChange={onFormInputChange}
            variant="accordion"
            type="number"
            name="pressureDrop"
            value={test.pressureDrop}
            step="0.1"
            min="0"
            max="200"
            autoComplete="off"
          />
        }
      />
    </>
  );
};

export default SvbPvbTestResultEdit;
